import { Model } from "@vuex-orm/core";

export default class User extends Model {
  static entity = 'users';

  static $fetch() {
    return this.api().get('Users/')
  }
  static $get (id) {
    return this.api().get(`Users/${id}/`)
  }
  static $post (data) {
    return this.api().post(`Users/`, data)
  }
  static $put (id, data) {
    return this.api().put(`Users/${id}/`, data)
  }

  static fields() {
    return {
      id: this.number(0),
      icon: this.string("mdi-account"),
      color: this.string("blue darken-4"),
      username: this.string(""),
      first_name: this.string(""),
      last_name: this.string(""),
      email: this.string("")
    };
  }

  get display_name() {
    return `${this.first_name} ${this.last_name}`;
  }
}
